import React, { PropsWithChildren } from 'react';
import type { ReactElement } from 'react';
export type Props = {
	icon: string;
	className?: string;
	text?: string;
};

export default function Icon({
	icon,
	className = '',
	text = '',
	children,
}: PropsWithChildren<Props>): ReactElement {
	return (
		<span className={`icon icon-${icon} ${className}`}>
			{text}
			{children}
		</span>
	);
}
